import React, { useState } from 'react';
import styles from "./styles/CredentialField.module.css"

const CredentialField = ({ text, field, success_text='Text Copied!' }) => {
    const [copied, setCopied] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleCopyText = () => {
        navigator.clipboard.writeText(text);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className={styles.field_data}>
            {
                field === 'password' ?
                <>
                    <span className={`${styles.field_copy} ${showPassword ? '' : styles.hide}`} >{text}</span>
                    <span className={`${styles.field_button} ${styles.password_button} ${showPassword ? '' : styles.hide}`} onClick={handleTogglePassword}>
                        <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z" fill="#B3B3B3"/>
                            <path d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z" fill="#B3B3B3"/>
                        </svg> 
                    </span>
                </> :
                <span className={styles.field_copy}>{text}</span>
            }
            
            <span className={styles.field_button} onClick={handleCopyText}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5 11.5V2.5H4.5" stroke="#0091EA" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11.5 4.5H2.5V13.5H11.5V4.5Z" stroke="#0091EA" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>

            {copied && <span className={styles.copy_message}>{success_text}</span>}
        </div>
    );
};

export default CredentialField;
